import React from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ProductList from "./ProductList";
import OrderInfo from "./OrderInfo";
import OrderStatus from "./OrderStatus";
import { Warning } from "@material-ui/icons";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

function Order({
    regNum,
    lines,
    status,
    total,
    managerName,
    managerContact,
    estimation,
    username,
    paymentId,
    goal,
    deliveryType,
    pickupPoint,
    partner,
}) {
    return (
        <Grid container justify="center" alignItems="center">
            <Grid container direction="column" style={{ maxWidth: 1140 }}>
                <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    wrap="nowrap"
                >
                {/* <Grid container justify="center" alignItems="center"> */}
                    <a 
                        href="https://t.me/+GAx5a_ALFltmYjFi" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <img 
                            src="/images/header_tg.svg" 
                            alt="Header TG" 
                            style={{
                                width: "100%",
                                maxWidth: 802,
                                height: "auto",
                                marginTop: 20,
                                marginBottom: 20,
                                cursor: "pointer",
                            }}
                        />
                    </a>
                </Grid>
                <Grid container justify="center" alignItems="center">
                    <Typography
                        className="order-title"
                        style={{
                            marginTop: 22,
                            marginBottom: 25,
                        }}
                    >
                        Заказ {regNum}
                    </Typography>
                </Grid>

                <div className="order-container">
                    <OrderStatus status={status} />

                    <Grid>
                        <Grid
                            container
                            direction="column"
                            style={{
                                width: "fit-content",
                            }}
                        >
                            <Status status={status} />
                            <Cart lines={lines} />
                        </Grid>
                    </Grid>
                    <OrderInfo
                        total={total}
                        status={status}
                        managerName={managerName}
                        managerContact={managerContact}
                        estimation={estimation}
                        username={username}
                        paymentId={paymentId}
                        goal={goal}
                        deliveryType={deliveryType}
                        pickupPoint={pickupPoint}
                        partner={partner}
                    />
                </div>
            </Grid>
        </Grid>
    );
}

const Status = ({ status }) => {
    return (
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            wrap="nowrap"
            style={{
                padding: "6px 24px",
                width: "fit-content",
            }}
        >
            {status === "submitted" && (
                <React.Fragment>
                    <Warning
                        style={{
                            minHeight: 20,
                            maxHeight: 20,
                            minWidth: 20,
                            maxWidth: 20,
                            marginRight: "8px",
                            color: "#ffa000",
                        }}
                    />
                    <Typography
                        style={{
                            padding: "8px 0",
                            color: "#ffa000",
                        }}
                    >
                        Оплата возможна только после подтверждения менеджером.
                    </Typography>
                </React.Fragment>
            )}

            {status === "paid" && (
                <React.Fragment>
                    <CheckCircleIcon
                        style={{
                            minHeight: 20,
                            maxHeight: 20,
                            minWidth: 20,
                            maxWidth: 20,
                            marginRight: "8px",
                            color: "#43a047",
                        }}
                    />
                    <Typography
                        style={{
                            padding: "8px 0",
                            color: "#43a047",
                        }}
                    >
                        Оплата прошла успешно, заказ будет передан в работу.
                    </Typography>
                </React.Fragment>
            )}
        </Grid>
    );
};

const Cart = ({ lines }) => {
    return (
        <Grid
            container
            style={{
                padding: "36px 50px 53px 21px",
                border: "1px solid #dcdcdc",
            }}
        >
            <Typography
                className="order-warning-text"
                style={{
                    lineHeight: 1.5,
                    fontWeight: 200,
                    marginBottom: 25,
                    width: "100%",
                    textAlign: "center",
                }}
            >
                Пожалуйста, проверьте состав заказа, чертежи и способ отгрузки
                перед оплатой
            </Typography>
            <ProductList lines={lines} />
        </Grid>
    );
};

export default Order;



// WEBPACK FOOTER //
// ./src/Order/Order.jsx